/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { QuarantinedMail } from '../model';
// @ts-ignore
import type { ReleaseProcessor } from '../model';
// @ts-ignore
import type { SearchField } from '../model';
/**
 * QuarantineApi - axios parameter creator
 * @export
 */
export const QuarantineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerDeleteQuarantinedMail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('quarantineControllerDeleteQuarantinedMail', 'id', id)
            const localVarPath = `/api/quarantine/deleteQuarantinedMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerDeleteQuarantinedMails: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('quarantineControllerDeleteQuarantinedMails', 'requestBody', requestBody)
            const localVarPath = `/api/quarantine/deleteQuarantinedMails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerGetQuarantinedMail: async (firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quarantine/getQuarantinedMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerGetQuarantinedMailById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('quarantineControllerGetQuarantinedMailById', 'id', id)
            const localVarPath = `/api/quarantine/getQuarantinedMailById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {number} [maxSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerGetQuarantinedMailContent: async (id?: string, maxSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quarantine/getQuarantinedMailContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerGetQuarantinedMailCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quarantine/getQuarantinedMailCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ReleaseProcessor} releaseProcessor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerReleaseQuarantinedMail: async (id: string, releaseProcessor: ReleaseProcessor, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('quarantineControllerReleaseQuarantinedMail', 'id', id)
            // verify required parameter 'releaseProcessor' is not null or undefined
            assertParamExists('quarantineControllerReleaseQuarantinedMail', 'releaseProcessor', releaseProcessor)
            const localVarPath = `/api/quarantine/releaseQuarantinedMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (releaseProcessor !== undefined) {
                localVarQueryParameter['releaseProcessor'] = releaseProcessor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {ReleaseProcessor} [releaseProcessor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerReleaseQuarantinedMails: async (requestBody: Array<string>, releaseProcessor?: ReleaseProcessor, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('quarantineControllerReleaseQuarantinedMails', 'requestBody', requestBody)
            const localVarPath = `/api/quarantine/releaseQuarantinedMails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (releaseProcessor !== undefined) {
                localVarQueryParameter['releaseProcessor'] = releaseProcessor;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchField} searchField 
         * @param {string} searchKey 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerSearchQuarantinedMail: async (searchField: SearchField, searchKey: string, firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('quarantineControllerSearchQuarantinedMail', 'searchField', searchField)
            // verify required parameter 'searchKey' is not null or undefined
            assertParamExists('quarantineControllerSearchQuarantinedMail', 'searchKey', searchKey)
            const localVarPath = `/api/quarantine/searchQuarantinedMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }

            if (searchKey !== undefined) {
                localVarQueryParameter['searchKey'] = searchKey;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchField} searchField 
         * @param {string} searchKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerSearchQuarantinedMailCount: async (searchField: SearchField, searchKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchField' is not null or undefined
            assertParamExists('quarantineControllerSearchQuarantinedMailCount', 'searchField', searchField)
            // verify required parameter 'searchKey' is not null or undefined
            assertParamExists('quarantineControllerSearchQuarantinedMailCount', 'searchKey', searchKey)
            const localVarPath = `/api/quarantine/searchQuarantinedMailCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }

            if (searchKey !== undefined) {
                localVarQueryParameter['searchKey'] = searchKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuarantineApi - functional programming interface
 * @export
 */
export const QuarantineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuarantineApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quarantineControllerDeleteQuarantinedMail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuarantinedMail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quarantineControllerDeleteQuarantinedMail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuarantineApi.quarantineControllerDeleteQuarantinedMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quarantineControllerDeleteQuarantinedMails(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quarantineControllerDeleteQuarantinedMails(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuarantineApi.quarantineControllerDeleteQuarantinedMails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quarantineControllerGetQuarantinedMail(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuarantinedMail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quarantineControllerGetQuarantinedMail(firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuarantineApi.quarantineControllerGetQuarantinedMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quarantineControllerGetQuarantinedMailById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuarantinedMail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quarantineControllerGetQuarantinedMailById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuarantineApi.quarantineControllerGetQuarantinedMailById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {number} [maxSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quarantineControllerGetQuarantinedMailContent(id?: string, maxSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quarantineControllerGetQuarantinedMailContent(id, maxSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuarantineApi.quarantineControllerGetQuarantinedMailContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quarantineControllerGetQuarantinedMailCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quarantineControllerGetQuarantinedMailCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuarantineApi.quarantineControllerGetQuarantinedMailCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ReleaseProcessor} releaseProcessor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quarantineControllerReleaseQuarantinedMail(id: string, releaseProcessor: ReleaseProcessor, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuarantinedMail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quarantineControllerReleaseQuarantinedMail(id, releaseProcessor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuarantineApi.quarantineControllerReleaseQuarantinedMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {ReleaseProcessor} [releaseProcessor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quarantineControllerReleaseQuarantinedMails(requestBody: Array<string>, releaseProcessor?: ReleaseProcessor, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quarantineControllerReleaseQuarantinedMails(requestBody, releaseProcessor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuarantineApi.quarantineControllerReleaseQuarantinedMails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SearchField} searchField 
         * @param {string} searchKey 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quarantineControllerSearchQuarantinedMail(searchField: SearchField, searchKey: string, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuarantinedMail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quarantineControllerSearchQuarantinedMail(searchField, searchKey, firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuarantineApi.quarantineControllerSearchQuarantinedMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SearchField} searchField 
         * @param {string} searchKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quarantineControllerSearchQuarantinedMailCount(searchField: SearchField, searchKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quarantineControllerSearchQuarantinedMailCount(searchField, searchKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuarantineApi.quarantineControllerSearchQuarantinedMailCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuarantineApi - factory interface
 * @export
 */
export const QuarantineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuarantineApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerDeleteQuarantinedMail(id: string, options?: any): AxiosPromise<QuarantinedMail> {
            return localVarFp.quarantineControllerDeleteQuarantinedMail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerDeleteQuarantinedMails(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.quarantineControllerDeleteQuarantinedMails(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerGetQuarantinedMail(firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<QuarantinedMail>> {
            return localVarFp.quarantineControllerGetQuarantinedMail(firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerGetQuarantinedMailById(id: string, options?: any): AxiosPromise<QuarantinedMail> {
            return localVarFp.quarantineControllerGetQuarantinedMailById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {number} [maxSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerGetQuarantinedMailContent(id?: string, maxSize?: number, options?: any): AxiosPromise<any> {
            return localVarFp.quarantineControllerGetQuarantinedMailContent(id, maxSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerGetQuarantinedMailCount(options?: any): AxiosPromise<number> {
            return localVarFp.quarantineControllerGetQuarantinedMailCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ReleaseProcessor} releaseProcessor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerReleaseQuarantinedMail(id: string, releaseProcessor: ReleaseProcessor, options?: any): AxiosPromise<QuarantinedMail> {
            return localVarFp.quarantineControllerReleaseQuarantinedMail(id, releaseProcessor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {ReleaseProcessor} [releaseProcessor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerReleaseQuarantinedMails(requestBody: Array<string>, releaseProcessor?: ReleaseProcessor, options?: any): AxiosPromise<void> {
            return localVarFp.quarantineControllerReleaseQuarantinedMails(requestBody, releaseProcessor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchField} searchField 
         * @param {string} searchKey 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerSearchQuarantinedMail(searchField: SearchField, searchKey: string, firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<QuarantinedMail>> {
            return localVarFp.quarantineControllerSearchQuarantinedMail(searchField, searchKey, firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchField} searchField 
         * @param {string} searchKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quarantineControllerSearchQuarantinedMailCount(searchField: SearchField, searchKey: string, options?: any): AxiosPromise<number> {
            return localVarFp.quarantineControllerSearchQuarantinedMailCount(searchField, searchKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuarantineApi - object-oriented interface
 * @export
 * @class QuarantineApi
 * @extends {BaseAPI}
 */
export class QuarantineApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineApi
     */
    public quarantineControllerDeleteQuarantinedMail(id: string, options?: RawAxiosRequestConfig) {
        return QuarantineApiFp(this.configuration).quarantineControllerDeleteQuarantinedMail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineApi
     */
    public quarantineControllerDeleteQuarantinedMails(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return QuarantineApiFp(this.configuration).quarantineControllerDeleteQuarantinedMails(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineApi
     */
    public quarantineControllerGetQuarantinedMail(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return QuarantineApiFp(this.configuration).quarantineControllerGetQuarantinedMail(firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineApi
     */
    public quarantineControllerGetQuarantinedMailById(id: string, options?: RawAxiosRequestConfig) {
        return QuarantineApiFp(this.configuration).quarantineControllerGetQuarantinedMailById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {number} [maxSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineApi
     */
    public quarantineControllerGetQuarantinedMailContent(id?: string, maxSize?: number, options?: RawAxiosRequestConfig) {
        return QuarantineApiFp(this.configuration).quarantineControllerGetQuarantinedMailContent(id, maxSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineApi
     */
    public quarantineControllerGetQuarantinedMailCount(options?: RawAxiosRequestConfig) {
        return QuarantineApiFp(this.configuration).quarantineControllerGetQuarantinedMailCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ReleaseProcessor} releaseProcessor 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineApi
     */
    public quarantineControllerReleaseQuarantinedMail(id: string, releaseProcessor: ReleaseProcessor, options?: RawAxiosRequestConfig) {
        return QuarantineApiFp(this.configuration).quarantineControllerReleaseQuarantinedMail(id, releaseProcessor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {ReleaseProcessor} [releaseProcessor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineApi
     */
    public quarantineControllerReleaseQuarantinedMails(requestBody: Array<string>, releaseProcessor?: ReleaseProcessor, options?: RawAxiosRequestConfig) {
        return QuarantineApiFp(this.configuration).quarantineControllerReleaseQuarantinedMails(requestBody, releaseProcessor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchField} searchField 
     * @param {string} searchKey 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineApi
     */
    public quarantineControllerSearchQuarantinedMail(searchField: SearchField, searchKey: string, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return QuarantineApiFp(this.configuration).quarantineControllerSearchQuarantinedMail(searchField, searchKey, firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchField} searchField 
     * @param {string} searchKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarantineApi
     */
    public quarantineControllerSearchQuarantinedMailCount(searchField: SearchField, searchKey: string, options?: RawAxiosRequestConfig) {
        return QuarantineApiFp(this.configuration).quarantineControllerSearchQuarantinedMailCount(searchField, searchKey, options).then((request) => request(this.axios, this.basePath));
    }
}

